import React from 'react'
import { CardinalOrientation } from 'walktour'

import { Text } from '@wartek-id/text-v1'

import { useSETrackEvent } from 'app/ConversationPage/hooks/useSETrackEvent'
import { CoachMark } from 'components/CoachMark'
import { useConversationLandingOnboardingStore } from 'stores/conversation'

import type { TSETrackConversationActivities } from 'types/conversation'

const ONBOARDING_STEPS = [
  {
    selector: '#coachmark-conversation-landing-input',
    description: null,
    customDescriptionRenderer: () => (
      <Text variant="heading-md">
        Silakan ketik pertanyaan apapun. Tidak perlu takut salah. Aru akan jawab
        dengan senang hati.
      </Text>
    ),
  },
  {
    selector: '#coachmark-conversation-landing-suggestions',
    description: null,
    customDescriptionRenderer: () => (
      <Text variant="heading-md">
        Mau tahu pertanyaan yang sering ditanya guru lain? Klik di sini.
      </Text>
    ),
  },
]

const ConversationLandingCoachMark = () => {
  const { landingOnboardingVariant, setLandingOnboardingFinished } =
    useConversationLandingOnboardingStore()

  const { SETrackConversationPage } = useSETrackEvent()

  const trackClickUnderstood = (step: number) => {
    SETrackConversationPage(
      `CLICK_GURU_AI_INTRODUCTION_UNDERSTOOD_${step}` as TSETrackConversationActivities,
      {
        event_trigger: 'GURU_AI_PAGE',
        screen_name: 'GURU_AI_PAGE',
        variant: landingOnboardingVariant,
      }
    )
  }

  const finishHandler = () => {
    setLandingOnboardingFinished()
    trackClickUnderstood(2)
  }

  const nextHandler = () => {
    trackClickUnderstood(1)
  }

  return (
    <CoachMark
      orientationPreferences={[CardinalOrientation.NORTH]}
      disableClose={true}
      disableCloseOnClick={true}
      disableMaskInteraction={false}
      disablePrev={true}
      isOpen={true}
      rootSelector="html"
      steps={ONBOARDING_STEPS}
      onFinish={finishHandler}
      onNext={nextHandler}
      tooltipConfigs={{
        nextLabel: 'Baik, mengerti',
        closeLabel: 'Baik, mengerti',
      }}
      tooltipVariant="white"
      maskRadius={8}
    />
  )
}

export default ConversationLandingCoachMark
